// WARNING: if you change this enum you also have to change enum in NG_SOS.EMS.Incidents.Hubs\WebAppState.cs
export enum WebAppState {
  None,
  WebAppSmsSent,
  LocationSmsSent,
  AppOpened,
  LocationPermissionRequested,
  LocationPermissionGranted,
  LocationUnavailableNotSupported,
  LocationPermissionDenied,
  LocationPositionUnavailable,
  LocationTimeout,
  CameraPermissionRequested,
  CameraPermissionGranted,
  CameraPermissionRejected,
  UnsupportedBrowser,
  StartingVideoTransmission,
  VideoTransmissionActive,
  VideoTransmissionFailed,
}
